import ApiService from "../ApiService";

const ActivateService = {
	activate: (ActivateAccountForm) => {
		return ApiService.post('/auth/activate-account', ActivateAccountForm).catch(error => {console.log(error)});
	}
}

export default ActivateService;